<template>
  <div>
    <exception-dialog
      @quantity="setQuantity"
      :dialog="exceptionDialog"
      @close="closeExeptionDialog"
    />
    <confirmation-dialog
      @confirmed="save"
      :onSetConfirmedDialog="setConfirmedDialog"
      :confirmedDialog="$store.state.medications.confirmedDialog"
      :title="title"
      :content="content"
    />

    <InsulinDialog
      :dialog="insulinDialog"
      :medication="medicationItem"
      @close="closeInsulinDialog"
      title="Insulin to administered"
    />

    <ControlledSubstanceDialog
      ref="controlled"
      :medication="selectedMedication.Medication"
      @close="closeControlledDialog"
      @controlled-data="getControlledData"
    />

    <share-link
      :dialog="shareLinkDialog"
      @close="close"
      :generatedURL="generatedURL"
    />
    <v-fab-transition>
      <v-btn
        class="fab-multiple"
        fab
        dark
        large
        color="primary"
        fixed
        right
        bottom
        v-show="multipleSelectedItem"
        @click="addMultipleItem"
        v-if="medCertified"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-snackbar v-model="msg" top :vertical="true">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark :color="color" text v-bind="attrs" @click="msg = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-card outlined tile height="100%">
      <v-expansion-panels class="overflow-y-auto" max-height="640">
        <!-- Morning Medications -->
        <v-expansion-panel hide-actions v-show="morningMedications.length > 0">
          <v-expansion-panel-header class="panel-header">
            <template v-slot:actions>
              <v-progress-circular
                :value="medication.morning.progress"
                :color="medication.morning.incomplete ? 'red' : 'success'"
                ><v-icon
                  :color="medication.morning.incomplete ? 'red' : 'success'"
                  small
                >
                  {{
                    medication.morning.progress === 100
                      ? "mdi-check"
                      : "mdi-medical-bag"
                  }}
                </v-icon></v-progress-circular
              >
            </template>
            <v-row align="center" justify="center" no-gutters>
              <v-col cols="12" sm="12" md="4" class="my-1">
                <v-row>
                  <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                    <v-avatar size="36px">
                      <v-icon color="teal">mdi-medical-bag</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                    <div class="pa-2 d-flex justify-center">
                      <strong>{{ schedule.morning }} Medications</strong>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="8">
                <v-row wrap>
                  <v-col cols="12" sm="12" md="12">
                    <div class="d-flex justify-center pa-1">
                      <v-row class="justify-center justify-md-start">
                        <v-chip
                          :color="
                            medication.morning.incomplete
                              ? 'red lighten-4'
                              : 'success lighten-4'
                          "
                          class="ml-0 mx-1 black--text my-1"
                          label
                          small
                        >
                          {{
                            medication.morning.incomplete
                              ? "INCOMPLETE"
                              : "COMPLETE"
                          }}
                        </v-chip>

                        <v-chip
                          color="teal lighten-4"
                          class="ml-0 black--text my-1"
                          label
                          small
                        >
                          <span class="text-overline"
                            >{{ medication.morning.completed }} /
                            {{ medication.morning.total }} Medication
                            Administered</span
                          >
                        </v-chip>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
                v-for="(
                  med, index
                ) in sortedMedications.morningMedications.filter(
                  (item) => item.isAdministered != true
                )"
                :key="index"
                :class="defaultMargin"
              >
                <v-item-group multiple>
                  <v-item v-slot="{ active, toggle }">
                    <v-card
                      class="my-2"
                      :color="active ? 'blue lighten-5' : ''"
                    >
                      <v-card class="mx-auto main-container bg-color" dark flat>
                        <v-container fluid class="mar-card--container">
                          <v-checkbox
                            class="mar-checkbox"
                            hide-details
                            @click="
                              toggle();
                              selectedItem({
                                ...med,
                                active: !active,
                              });
                            "
                          ></v-checkbox>

                          <div class="d-flex flex-column item-container">
                            <v-card-title
                              class="text-body-1 mr-5"
                              v-html="med.Medication"
                            ></v-card-title>

                            <v-card-text class="flex-grow-1">
                              <div class="text-overline white--text">
                                INSTRUCTION
                              </div>
                              <div class="white--text">
                                {{ med.MARInstructions.substring(0, 90) }}
                                <a
                                  color="#BBDEFB"
                                  class="caption white--text"
                                  v-show="instructionLength(med)"
                                  @click="instruction(index)"
                                  >...Read More
                                </a>
                              </div>
                            </v-card-text>

                            <v-expand-transition>
                              <v-card
                                v-if="reveal && cardIndex === index"
                                class="transition-fast-in-fast-out v-card--reveal"
                                style="height: 500"
                                flat
                              >
                                <v-card-text class="pb-0 black--text">
                                  <p class="pa-2">{{ med.MARInstructions }}</p>
                                </v-card-text>
                                <v-card-actions class="pt-0">
                                  <v-btn
                                    text
                                    color="primary accent-4"
                                    @click="reveal = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-expand-transition>

                            <!-- <v-card-text>
                              <div class="text-overline white--text">
                                diagnosis
                                 <a
                                  color="#BBDEFB"
                                  class="caption white--text"
                                  v-show="diagnosisLength(med)"
                                  @click="diagnosis(index)"
                                  >...Read More
                                </a>
                              </div>
                              <div class=" white--text">
                                {{ med.Diagnosis }}
                              </div>
                            </v-card-text> -->

                            <!-- <v-expand-transition>
                              <v-card
                                v-if="diagnosisReveal && diagnosisCardIndex === index"
                                class="transition-fast-in-fast-out v-card--reveal"
                                style="height: 500;"
                                flat
                              >
                                <v-card-text class="pb-0 black--text">
                                  <p class="pa-2">{{ med.Diagnosis }}</p>
                                </v-card-text>
                                <v-card-actions class="pt-0">
                                  <v-btn
                                    text
                                    color="primary accent-4"
                                    @click="diagnosisReveal = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-expand-transition> -->

                            <v-row align="center" justify="end">
                              <v-icon
                                class="mr-3 my-n5"
                                @click="createShareLink(med)"
                              >
                                mdi-share-variant
                              </v-icon>
                            </v-row>
                          </div>
                        </v-container>
                      </v-card>

                      <v-row class="ma-2" dense>
                        <v-card-text
                          ><div class="text-subtitle-3">Diagnosis</div>
                          <v-divider class="mt-1"></v-divider>
                        </v-card-text>
                        <div class="item-container--diagnosis mb-2">
                          <!-- {{ med.MARInstructions.substring(0, 90) }} -->
                          <v-card-text>
                            <div class="diagnosis-container">
                              {{ med.Diagnosis.substring(0, 80) }}
                              <a
                                color="#BBDEFB"
                                class="caption"
                                v-show="diagnosisLength(med)"
                                @click="diagnosis(index)"
                                >Read More
                              </a>

                              <v-expand-transition>
                                <v-card
                                  v-if="
                                    diagnosisReveal &&
                                    diagnosisCardIndex === index
                                  "
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                  flat
                                >
                                  <v-card-text class="pb-0 black--text">
                                    <p class="pa-2">{{ med.Diagnosis }}</p>
                                  </v-card-text>
                                  <v-card-actions class="pt-0">
                                    <v-btn
                                      text
                                      color="primary accent-4"
                                      @click="diagnosisReveal = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </div>
                          </v-card-text>
                        </div>
                      </v-row>

                      <v-row class="ma-2" dense>
                        <v-col cols="12" md="6">
                          <!-- <v-select
                            label="Quantity"
                            v-model="med.Quantity"
                            :items="med.qty"
                            hide-details
                            outlined
                            @change="onSelectQuantity(med.Quantity, med)"
                          ></v-select> -->
                          <v-text-field
                            label="Quantity"
                            v-model="med.Quantity"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Admin Time"
                            v-model="med.newAdminTime"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <!-- IF VITALS ARE REQUIRED -->
                        <template v-for="(vital, index) in med.VitalsRequired">
                          <v-row :key="index" class="ma-0 pa-0">
                            <v-col
                              cols="12"
                              :md="vital === 'BloodSugar' ? 6 : 12"
                              class="pa-1"
                            >
                              <v-text-field
                                :label="vital"
                                v-model="med.newVitalsRequired[index]"
                                :error-messages="med.ErrorVitalsRequired[index]"
                                @input="checkError(med, index)"
                                outlined
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" class="pa-1">
                              <v-text-field
                                v-if="
                                  vital === 'BloodSugar' &&
                                  checkMedicationType(med.Medication)
                                "
                                v-model="med.Insulin"
                                label="Insulin to Administer"
                                outlined
                                readonly
                                :error-messages="med.insulinError"
                                @click="openInsulinDialog(med, 'morning')"
                                @input="
                                  () =>
                                    med.Insulin === ''
                                      ? (med.insulinError =
                                          'Insulin is required')
                                      : (med.insulinError = '')
                                "
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </template>
                        <v-col cols="12" md="12">
                          <v-textarea
                            v-if="active"
                            label="Notes"
                            outlined
                            hide-details
                            v-model="newNotes"
                            rows="2"
                            row-height="20"
                          ></v-textarea>
                          <v-textarea
                            v-else
                            label="Notes"
                            outlined
                            hide-details
                            rows="2"
                            row-height="20"
                            v-model="med.newNotes"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-text-field
                            v-show="active"
                            label="Amount Administered to Client"
                            v-model="newAmountAdministered"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                          <v-text-field
                            v-show="!active"
                            label="Amount Administered to Client"
                            v-model="med.newAmountAdministered"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Exception"
                            :items="exceptions"
                            v-model="newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Exception"
                            :items="exceptions"
                            v-model="med.newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="med.isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n8">
                          <v-checkbox
                            v-show="active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="signed"
                            hide-details
                          ></v-checkbox>
                          <v-checkbox
                            v-show="!active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="med.signed"
                            hide-details
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n3">
                          <v-text-field
                            v-show="active"
                            v-model="newSignature"
                            :disabled="signed"
                            :error-messages="error"
                          ></v-text-field>

                          <v-text-field
                            v-show="!active"
                            v-model="med.newSignature"
                            :disabled="med.signed"
                            :error-messages="med.error"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-card-actions>
                        <!-- <v-btn
                          class="bg-color"
                          dark
                          block
                          @click="addMAR(med)"
                          :disabled="
                            $store.state.medications.isSelectedMultipleItem
                          "
                        >
                          submit
                        </v-btn> -->

                        <v-btn
                          v-if="medCertified && !userRole"
                          class="bg-color"
                          dark
                          block
                          :loading="$store.state.medications.isLoading"
                          :disabled="isDisable"
                          @click="addMAR(med)"
                        >
                          submit
                          <template v-slot:loader>
                            <span>Loading...</span>
                          </template>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- End of Morning Medications -->

        <!-- Afternoon Medications -->
        <v-expansion-panel
          hide-actions
          v-show="afternoonMedications.length > 0"
        >
          <v-expansion-panel-header class="panel-header">
            <template v-slot:actions>
              <v-progress-circular
                :value="medication.afternoon.progress"
                :color="medication.afternoon.incomplete ? 'red' : 'success'"
                ><v-icon
                  :color="medication.afternoon.incomplete ? 'red' : 'success'"
                  small
                >
                  {{
                    medication.afternoon.progress === 100
                      ? "mdi-check"
                      : "mdi-medical-bag"
                  }}
                </v-icon></v-progress-circular
              >
            </template>

            <v-row align="center" justify="center" no-gutters>
              <v-col cols="12" sm="12" md="4" class="my-1">
                <v-row>
                  <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                    <v-avatar size="36px">
                      <v-icon color="teal">mdi-medical-bag</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                    <div class="pa-2 d-flex justify-center">
                      <strong>{{ schedule.afternoon }} Medications</strong>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="8">
                <v-row wrap>
                  <v-col cols="12" sm="12" md="12">
                    <div class="d-flex justify-center pa-1">
                      <v-row class="justify-center justify-md-start">
                        <v-chip
                          :color="
                            medication.afternoon.incomplete
                              ? 'red lighten-4'
                              : 'success lighten-4'
                          "
                          class="ml-0 mx-1 black--text my-1"
                          label
                          small
                        >
                          {{
                            medication.afternoon.incomplete
                              ? "INCOMPLETE"
                              : "COMPLETE"
                          }}
                        </v-chip>

                        <v-chip
                          color="teal lighten-4"
                          class="ml-0 black--text my-1"
                          label
                          small
                        >
                          <span class="text-overline"
                            >{{ medication.afternoon.completed }} /
                            {{ medication.afternoon.total }} Medication
                            Administered</span
                          >
                        </v-chip>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
                v-for="(
                  med, index
                ) in sortedMedications.afternoonMedications.filter(
                  (item) => item.isAdministered != true
                )"
                :key="index"
                :class="defaultMargin"
              >
                <v-item-group multiple>
                  <v-item v-slot="{ active, toggle }">
                    <v-card
                      class="my-2"
                      :color="active ? 'blue lighten-5' : ''"
                    >
                      <v-card class="mx-auto main-container bg-color" dark flat>
                        <v-container fluid class="mar-card--container">
                          <v-checkbox
                            class="mar-checkbox"
                            hide-details
                            @click="
                              toggle();
                              selectedItem({
                                ...med,
                                active: !active,
                              });
                            "
                          ></v-checkbox>

                          <div class="d-flex flex-column item-container">
                            <v-card-title
                              class="text-body-1 mr-5"
                              v-html="med.Medication"
                            ></v-card-title>

                            <v-card-text class="flex-grow-1">
                              <div class="text-overline white--text">
                                INSTRUCTION
                              </div>
                              <div class="white--text">
                                {{ med.MARInstructions.substring(0, 90) }}
                                <a
                                  color="#BBDEFB"
                                  class="caption white--text"
                                  v-show="instructionLength(med)"
                                  @click="instruction(index)"
                                  >...Read More
                                </a>
                              </div>
                            </v-card-text>

                            <v-expand-transition>
                              <v-card
                                v-if="reveal && cardIndex === index"
                                class="transition-fast-in-fast-out v-card--reveal"
                                style="height: 500"
                                flat
                              >
                                <v-card-text class="pb-0 black--text">
                                  <p class="pa-2">{{ med.MARInstructions }}</p>
                                </v-card-text>
                                <v-card-actions class="pt-0">
                                  <v-btn
                                    text
                                    color="primary accent-4"
                                    @click="reveal = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-expand-transition>

                            <!-- <v-card-text>
                              <div class="text-overline white--text">
                                diagnosis
                              </div>
                              <div class=" white--text">
                                {{ med.Diagnosis }}
                              </div>
                            </v-card-text> -->

                            <v-row align="center" justify="end">
                              <v-icon
                                class="mr-3 my-n5"
                                @click="createShareLink(med)"
                              >
                                mdi-share-variant
                              </v-icon>
                            </v-row>
                          </div>
                        </v-container>
                      </v-card>

                      <v-row class="ma-2" dense>
                        <v-card-text
                          ><div class="text-subtitle-3">Diagnosis</div>
                          <v-divider class="mt-1"></v-divider>
                        </v-card-text>
                        <div class="item-container--diagnosis mb-2">
                          <!-- {{ med.MARInstructions.substring(0, 90) }} -->
                          <v-card-text>
                            <div class="diagnosis-container">
                              {{ med.Diagnosis.substring(0, 80) }}
                              <a
                                color="#BBDEFB"
                                class="caption"
                                v-show="diagnosisLength(med)"
                                @click="diagnosis(index)"
                                >Read More
                              </a>

                              <v-expand-transition>
                                <v-card
                                  v-if="
                                    diagnosisReveal &&
                                    diagnosisCardIndex === index
                                  "
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                  flat
                                >
                                  <v-card-text class="pb-0 black--text">
                                    <p class="pa-2">{{ med.Diagnosis }}</p>
                                  </v-card-text>
                                  <v-card-actions class="pt-0">
                                    <v-btn
                                      text
                                      color="primary accent-4"
                                      @click="diagnosisReveal = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </div>
                          </v-card-text>
                        </div>
                      </v-row>

                      <v-row class="ma-2" dense>
                        <v-col cols="12" md="6">
                          <!-- <v-select
                            label="Quantity"
                            v-model="med.Quantity"
                            :items="med.qty"
                            hide-details
                            outlined
                            @change="onSelectQuantity(med.Quantity, med)"
                          ></v-select> -->
                          <v-text-field
                            label="Quantity"
                            v-model="med.Quantity"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Admin Time"
                            v-model="med.newAdminTime"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <!-- IF VITALS ARE REQUIRED -->
                        <template v-for="(vital, index) in med.VitalsRequired">
                          <v-row :key="index" class="ma-0 pa-0">
                            <v-col
                              cols="12"
                              :md="vital === 'BloodSugar' ? 6 : 12"
                              class="pa-1"
                            >
                              <v-text-field
                                :label="vital"
                                v-model="med.newVitalsRequired[index]"
                                :error-messages="med.ErrorVitalsRequired[index]"
                                @input="checkError(med, index)"
                                outlined
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" class="pa-1">
                              <v-text-field
                                v-if="
                                  vital === 'BloodSugar' &&
                                  checkMedicationType(med.Medication)
                                "
                                v-model="med.Insulin"
                                readonly
                                label="Insulin to Administer"
                                outlined
                                :error-messages="med.insulinError"
                                @click="openInsulinDialog(med, 'afternoon')"
                                @input="
                                  () =>
                                    med.Insulin === ''
                                      ? (med.insulinError =
                                          'Insulin is required')
                                      : (med.insulinError = '')
                                "
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </template>
                        <v-col cols="12" md="12">
                          <v-textarea
                            v-if="active"
                            label="Notes"
                            outlined
                            hide-details
                            v-model="newNotes"
                            rows="2"
                            row-height="20"
                          ></v-textarea>
                          <v-textarea
                            v-else
                            label="Notes"
                            outlined
                            hide-details
                            rows="2"
                            row-height="20"
                            v-model="med.newNotes"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-text-field
                            label="Amount Administered to Client"
                            v-model="med.newAmountAdministered"
                            :items="adminTime"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Exception"
                            :items="exceptions"
                            v-model="newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Exception"
                            :items="exceptions"
                            v-model="med.newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="med.isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n8">
                          <v-checkbox
                            v-show="active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="signed"
                            hide-details
                          ></v-checkbox>
                          <v-checkbox
                            v-show="!active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="med.signed"
                            hide-details
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n3">
                          <v-text-field
                            v-show="active"
                            v-model="newSignature"
                            :disabled="signed"
                            :error-messages="error"
                          ></v-text-field>

                          <v-text-field
                            v-show="!active"
                            v-model="med.newSignature"
                            :disabled="med.signed"
                            :error-messages="med.error"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-card-actions>
                        <!-- <v-btn
                          class="bg-color"
                          dark
                          block
                          @click="addMAR(med)"
                          :disabled="
                            $store.state.medications.isSelectedMultipleItem
                          "
                        >
                          submit
                        </v-btn> -->
                        <v-btn
                          v-if="medCertified && !userRole"
                          class="bg-color"
                          dark
                          block
                          :loading="$store.state.medications.isLoading"
                          :disabled="isDisable"
                          @click="addMAR(med)"
                        >
                          submit
                          <template v-slot:loader>
                            <span>Loading...</span>
                          </template>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- End of Afternoon Medications -->

        <!-- Evening Medications -->
        <v-expansion-panel hide-actions v-show="eveningMedications.length > 0">
          <v-expansion-panel-header class="panel-header">
            <template v-slot:actions>
              <v-progress-circular
                :value="medication.evening.progress"
                :color="medication.evening.incomplete ? 'red' : 'success'"
                ><v-icon
                  :color="medication.evening.incomplete ? 'red' : 'success'"
                  small
                >
                  {{
                    medication.evening.progress === 100
                      ? "mdi-check"
                      : "mdi-medical-bag"
                  }}
                </v-icon></v-progress-circular
              >
            </template>
            <v-row align="center" justify="center" no-gutters>
              <v-col cols="12" sm="12" md="4" class="my-1">
                <v-row>
                  <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                    <v-avatar size="36px">
                      <v-icon color="teal">mdi-medical-bag</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                    <div class="pa-2 d-flex justify-center">
                      <strong>{{ schedule.evening }} Medications</strong>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="8">
                <v-row wrap>
                  <v-col cols="12" sm="12" md="12">
                    <div class="d-flex justify-center pa-1">
                      <v-row class="justify-center justify-md-start">
                        <v-chip
                          :color="
                            medication.evening.incomplete
                              ? 'red lighten-4'
                              : 'success lighten-4'
                          "
                          class="ml-0 mx-1 black--text my-1"
                          label
                          small
                        >
                          {{
                            medication.evening.incomplete
                              ? "INCOMPLETE"
                              : "COMPLETE"
                          }}
                        </v-chip>

                        <v-chip
                          color="teal lighten-4"
                          class="ml-0 black--text my-1"
                          label
                          small
                        >
                          <span class="text-overline"
                            >{{ medication.evening.completed }} /
                            {{ medication.evening.total }} Medication
                            Administered</span
                          >
                        </v-chip>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
                v-for="(
                  med, index
                ) in sortedMedications.eveningMedications.filter(
                  (item) => item.isAdministered != true
                )"
                :key="index"
                :class="defaultMargin"
              >
                <v-item-group multiple>
                  <v-item v-slot="{ active, toggle }">
                    <v-card
                      class="my-2"
                      :color="active ? 'blue lighten-5' : ''"
                    >
                      <v-card class="mx-auto main-container bg-color" dark flat>
                        <v-container fluid class="mar-card--container">
                          <v-checkbox
                            class="mar-checkbox"
                            hide-details
                            @click="
                              toggle();
                              selectedItem({
                                ...med,
                                active: !active,
                              });
                            "
                          ></v-checkbox>

                          <div class="d-flex flex-column item-container">
                            <v-card-title
                              class="text-body-1 mr-5"
                              v-html="med.Medication"
                            ></v-card-title>

                            <v-card-text class="flex-grow-1">
                              <div class="text-overline white--text">
                                INSTRUCTION
                              </div>
                              <div class="white--text">
                                {{ med.MARInstructions.substring(0, 90) }}
                                <a
                                  color="#BBDEFB"
                                  class="caption white--text"
                                  v-show="instructionLength(med)"
                                  @click="instruction(index)"
                                  >...Read More
                                </a>
                              </div>
                            </v-card-text>

                            <v-expand-transition>
                              <v-card
                                v-if="reveal && cardIndex === index"
                                class="transition-fast-in-fast-out v-card--reveal"
                                style="height: 500"
                                flat
                              >
                                <v-card-text class="pb-0 black--text">
                                  <p class="pa-2">{{ med.MARInstructions }}</p>
                                </v-card-text>
                                <v-card-actions class="pt-0">
                                  <v-btn
                                    text
                                    color="primary accent-4"
                                    @click="reveal = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-expand-transition>

                            <!-- <v-card-text>
                              <div class="text-overline white--text">
                                diagnosis
                              </div>
                              <div class=" white--text">
                                {{ med.Diagnosis }}
                              </div>
                            </v-card-text> -->

                            <v-row align="center" justify="end">
                              <v-icon
                                class="mr-3 my-n5"
                                @click="createShareLink(med)"
                              >
                                mdi-share-variant
                              </v-icon>
                            </v-row>
                          </div>
                        </v-container>
                      </v-card>

                      <v-row class="ma-2" dense>
                        <v-card-text
                          ><div class="text-subtitle-3">Diagnosis</div>
                          <v-divider class="mt-1"></v-divider>
                        </v-card-text>
                        <div class="item-container--diagnosis mb-2">
                          <!-- {{ med.MARInstructions.substring(0, 90) }} -->
                          <v-card-text>
                            <div class="diagnosis-container">
                              {{ med.Diagnosis.substring(0, 80) }}
                              <a
                                color="#BBDEFB"
                                class="caption"
                                v-show="diagnosisLength(med)"
                                @click="diagnosis(index)"
                                >Read More
                              </a>

                              <v-expand-transition>
                                <v-card
                                  v-if="
                                    diagnosisReveal &&
                                    diagnosisCardIndex === index
                                  "
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                  flat
                                >
                                  <v-card-text class="pb-0 black--text">
                                    <p class="pa-2">{{ med.Diagnosis }}</p>
                                  </v-card-text>
                                  <v-card-actions class="pt-0">
                                    <v-btn
                                      text
                                      color="primary accent-4"
                                      @click="diagnosisReveal = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </div>
                          </v-card-text>
                        </div>
                      </v-row>

                      <v-row class="ma-2" dense>
                        <v-col cols="12" md="6">
                          <!-- <v-select
                            label="Quantity"
                            v-model="med.Quantity"
                            :items="med.qty"
                            hide-details
                            outlined
                            @change="onSelectQuantity(med.Quantity, med)"
                          ></v-select> -->
                          <v-text-field
                            label="Quantity"
                            v-model="med.Quantity"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Admin Time"
                            v-model="med.newAdminTime"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <!-- IF VITALS ARE REQUIRED -->
                        <template v-for="(vital, index) in med.VitalsRequired">
                          <v-row :key="index" class="ma-0 pa-0">
                            <v-col
                              cols="12"
                              :md="vital === 'BloodSugar' ? 6 : 12"
                              class="pa-1"
                            >
                              <v-text-field
                                :label="vital"
                                v-model="med.newVitalsRequired[index]"
                                :error-messages="med.ErrorVitalsRequired[index]"
                                @input="checkError(med, index)"
                                outlined
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" class="pa-1">
                              <v-text-field
                                v-if="
                                  vital === 'BloodSugar' &&
                                  checkMedicationType(med.Medication)
                                "
                                v-model="med.Insulin"
                                readonly
                                label="Insulin to Administer"
                                outlined
                                :error-messages="med.insulinError"
                                @click="openInsulinDialog(med, 'evening')"
                                @input="
                                  () =>
                                    med.Insulin === ''
                                      ? (med.insulinError =
                                          'Insulin is required')
                                      : (med.insulinError = '')
                                "
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </template>
                        <v-col cols="12" md="12">
                          <v-textarea
                            v-if="active"
                            label="Notes"
                            outlined
                            hide-details
                            v-model="newNotes"
                            rows="2"
                            row-height="20"
                          ></v-textarea>
                          <v-textarea
                            v-else
                            label="Notes"
                            outlined
                            hide-details
                            rows="2"
                            row-height="20"
                            v-model="med.newNotes"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-text-field
                            label="Amount Administered to Client"
                            v-model="med.newAmountAdministered"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Exception"
                            :items="exceptions"
                            v-model="newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Exception"
                            :items="exceptions"
                            v-model="med.newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="med.isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n8">
                          <v-checkbox
                            v-show="active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="signed"
                            hide-details
                          ></v-checkbox>
                          <v-checkbox
                            v-show="!active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="med.signed"
                            hide-details
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n3">
                          <v-text-field
                            v-show="active"
                            v-model="newSignature"
                            :disabled="signed"
                            :error-messages="error"
                          ></v-text-field>

                          <v-text-field
                            v-show="!active"
                            v-model="med.newSignature"
                            :disabled="med.signed"
                            :error-messages="med.error"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-card-actions>
                        <!-- <v-btn
                          class="bg-color"
                          dark
                          block
                          @click="addMAR(med)"
                          :disabled="
                            $store.state.medications.isSelectedMultipleItem
                          "
                        >
                          submit
                        </v-btn> -->
                        <v-btn
                          v-if="medCertified && !userRole"
                          class="bg-color"
                          dark
                          block
                          :loading="$store.state.medications.isLoading"
                          :disabled="isDisable"
                          @click="addMAR(med)"
                        >
                          submit
                          <template v-slot:loader>
                            <span>Loading...</span>
                          </template>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- End of Evening Medications -->

        <!-- Daily/PRN Medications -->
        <v-expansion-panel hide-actions v-show="dailyPRNMedications.length > 0">
          <v-expansion-panel-header class="panel-header">
            <template v-slot:actions>
              <v-progress-circular
                :value="medication.daily.progress"
                :color="medication.daily.incomplete ? 'red' : 'success'"
                ><v-icon
                  :color="medication.daily.incomplete ? 'red' : 'success'"
                  small
                >
                  {{
                    medication.progress === 100
                      ? "mdi-check"
                      : "mdi-medical-bag"
                  }}
                </v-icon></v-progress-circular
              >
            </template>

            <v-row align="center" justify="center" no-gutters>
              <v-col cols="12" sm="12" md="4" class="my-1">
                <v-row>
                  <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                    <v-avatar size="36px">
                      <v-icon color="teal">mdi-medical-bag</v-icon>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                    <div class="pa-2 d-flex justify-center">
                      <strong>{{ schedule.daily }} Medications</strong>
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" sm="12" md="8">
                <v-row wrap>
                  <v-col cols="12" sm="12" md="12">
                    <div class="d-flex justify-center pa-1">
                      <v-row class="justify-center justify-md-start">
                        <v-chip
                          :color="
                            medication.daily.incomplete
                              ? 'red lighten-4'
                              : 'success lighten-4'
                          "
                          class="ml-0 mx-1 black--text my-1"
                          label
                          small
                        >
                          {{
                            medication.daily.incomplete
                              ? "INCOMPLETE"
                              : "COMPLETE"
                          }}
                        </v-chip>

                        <v-chip
                          color="teal lighten-4"
                          class="ml-0 black--text my-1"
                          label
                          small
                        >
                          <span class="text-overline"
                            >{{ medication.daily.completed }} /
                            {{ medication.daily.total }} Medication
                            Administered</span
                          >
                        </v-chip>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col
                cols="12"
                md="4"
                v-for="(
                  med, index
                ) in sortedMedications.dailyPRNMedications.filter(
                  (item) => item.isAdministered != true
                )"
                :key="index"
                :class="defaultMargin"
              >
                <v-item-group multiple>
                  <v-item v-slot="{ active, toggle }">
                    <v-card
                      class="my-2"
                      :color="active ? 'blue lighten-5' : ''"
                    >
                      <v-card class="mx-auto main-container bg-color" dark flat>
                        <v-container fluid class="mar-card--container">
                          <v-checkbox
                            class="mar-checkbox"
                            hide-details
                            @click="
                              toggle();
                              selectedItem({
                                ...med,
                                active: !active,
                              });
                            "
                          ></v-checkbox>

                          <div class="d-flex flex-column item-container">
                            <v-card-title
                              class="text-body-1 mr-5"
                              v-html="med.Medication"
                            ></v-card-title>

                            <v-card-text class="flex-grow-1">
                              <div class="text-overline white--text">
                                INSTRUCTION
                              </div>
                              <div class="white--text">
                                {{ med.MARInstructions.substring(0, 90) }}
                                <a
                                  color="#BBDEFB"
                                  class="caption white--text"
                                  v-show="instructionLength(med)"
                                  @click="instruction(index)"
                                  >...Read More
                                </a>
                              </div>
                            </v-card-text>

                            <v-expand-transition>
                              <v-card
                                v-if="reveal && cardIndex === index"
                                class="transition-fast-in-fast-out v-card--reveal"
                                style="height: 500"
                                flat
                              >
                                <v-card-text class="pb-0 black--text">
                                  <p class="pa-2">{{ med.MARInstructions }}</p>
                                </v-card-text>
                                <v-card-actions class="pt-0">
                                  <v-btn
                                    text
                                    color="primary accent-4"
                                    @click="reveal = false"
                                  >
                                    Close
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-expand-transition>

                            <!-- <v-card-text>
                              <div class="text-overline white--text">
                                diagnosis
                              </div>
                              <div class=" white--text">
                                {{ med.Diagnosis }}
                              </div>
                            </v-card-text> -->

                            <v-row align="center" justify="end">
                              <v-icon
                                class="mr-3 my-n5"
                                @click="createShareLink(med)"
                              >
                                mdi-share-variant
                              </v-icon>
                            </v-row>
                          </div>
                        </v-container>
                      </v-card>

                      <v-row class="ma-2" dense>
                        <v-card-text
                          ><div class="text-subtitle-3">Diagnosis</div>
                          <v-divider class="mt-1"></v-divider>
                        </v-card-text>
                        <div class="item-container--diagnosis mb-2">
                          <!-- {{ med.MARInstructions.substring(0, 90) }} -->
                          <v-card-text>
                            <div class="diagnosis-container">
                              {{ med.Diagnosis.substring(0, 80) }}
                              <a
                                color="#BBDEFB"
                                class="caption"
                                v-show="diagnosisLength(med)"
                                @click="diagnosis(index)"
                                >Read More
                              </a>

                              <v-expand-transition>
                                <v-card
                                  v-if="
                                    diagnosisReveal &&
                                    diagnosisCardIndex === index
                                  "
                                  class="transition-fast-in-fast-out v-card--reveal"
                                  style="height: 500"
                                  flat
                                >
                                  <v-card-text class="pb-0 black--text">
                                    <p class="pa-2">{{ med.Diagnosis }}</p>
                                  </v-card-text>
                                  <v-card-actions class="pt-0">
                                    <v-btn
                                      text
                                      color="primary accent-4"
                                      @click="diagnosisReveal = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-expand-transition>
                            </div>
                          </v-card-text>
                        </div>
                      </v-row>

                      <v-row class="ma-2" dense>
                        <v-col cols="12" md="6">
                          <!-- <v-select
                            label="Quantity"
                            v-model="med.Quantity"
                            :items="med.qty"
                            hide-details
                            outlined
                            @change="onSelectQuantity(med.Quantity, med)"
                          ></v-select> -->
                          <v-text-field
                            label="Quantity"
                            v-model="med.Quantity"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            label="Admin Time"
                            v-model="med.newAdminTime"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <!-- IF VITALS ARE REQUIRED -->
                        <template v-for="(vital, index) in med.VitalsRequired">
                          <v-row :key="index" class="ma-0 pa-0">
                            <v-col
                              cols="12"
                              :md="vital === 'BloodSugar' ? 6 : 12"
                              class="pa-1"
                            >
                              <v-text-field
                                :label="vital"
                                v-model="med.newVitalsRequired[index]"
                                :error-messages="med.ErrorVitalsRequired[index]"
                                @input="checkError(med, index)"
                                outlined
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6" class="pa-1">
                              <v-text-field
                                v-if="
                                  vital === 'BloodSugar' &&
                                  checkMedicationType(med.Medication)
                                "
                                v-model="med.Insulin"
                                readonly
                                label="Insulin to Administer"
                                outlined
                                :error-messages="med.insulinError"
                                @click="openInsulinDialog(med, 'prn')"
                                @input="
                                  () =>
                                    med.Insulin === ''
                                      ? (med.insulinError =
                                          'Insulin is required')
                                      : (med.insulinError = '')
                                "
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </template>
                        <v-col cols="12" md="12">
                          <v-textarea
                            v-if="active"
                            label="Notes"
                            outlined
                            hide-details
                            v-model="newNotes"
                            rows="3"
                            row-height="25"
                          ></v-textarea>
                          <v-textarea
                            v-else
                            label="Notes"
                            outlined
                            hide-details
                            rows="3"
                            row-height="25"
                            v-model="med.newNotes"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" md="12">
                          <v-text-field
                            label="Amount Administered to Client"
                            v-model="med.newAmountAdministered"
                            hide-details
                            outlined
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Exception"
                            :items="exceptions"
                            v-model="newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Exception"
                            :items="exceptions"
                            v-model="med.newException"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectException(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            v-show="active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                          <v-select
                            v-show="!active"
                            label="Controlled"
                            :items="['Yes', 'No']"
                            v-model="med.isControlled"
                            outlined
                            clearable
                            @click:clear="onClear(true)"
                            @change="onSelectControlled(med)"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n8">
                          <v-checkbox
                            v-show="active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="signed"
                            hide-details
                          ></v-checkbox>
                          <v-checkbox
                            v-show="!active"
                            label="Signature"
                            @change="addSignature(med, active)"
                            v-model="med.signed"
                            hide-details
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n3">
                          <v-text-field
                            v-show="active"
                            v-model="newSignature"
                            :disabled="signed"
                            readonly
                            :error-messages="error"
                          ></v-text-field>

                          <v-text-field
                            v-show="!active"
                            v-model="med.newSignature"
                            :disabled="med.signed"
                            readonly
                            :error-messages="med.error"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-card-actions>
                        <!-- <v-btn
                          class="bg-color"
                          dark
                          block
                          @click="addMAR(med)"
                          :disabled="
                            $store.state.medications.isSelectedMultipleItem
                          "
                        >
                          submit
                        </v-btn> -->
                        <v-btn
                          v-if="medCertified && !userRole"
                          class="bg-color"
                          dark
                          block
                          :loading="$store.state.medications.isLoading"
                          :disabled="isDisable"
                          @click="addMAR(med)"
                        >
                          submit
                          <template v-slot:loader>
                            <span>Loading...</span>
                          </template>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- End of Daily/PRN  Medications -->
      </v-expansion-panels>
    </v-card>
  </div>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import { mapMutations, mapState, mapActions } from "vuex";
const url = require("@/client_config/config").url;
const shareUrl = require("@/client_config/config").shareUrl;
import ExceptionDialog from "@/components/shared/ExceptionDialog";
import ConfirmationDialog from "@/components/shared/ConfirmationDialog";
import ShareLink from "@/components/shared/ShareLink";
import moment from "moment";
import { setUserSignatureTz } from "../../../../utils/timezone";
import InsulinDialog from "./InsulinDialog";
import ControlledSubstanceDialog from "./ControlledSubstanceDialog";
export default {
  components: {
    ExceptionDialog,
    ShareLink,
    ConfirmationDialog,
    InsulinDialog,
    ControlledSubstanceDialog,
  },
  props: {
    morningMedications: {
      type: Array,
    },
    afternoonMedications: {
      type: Array,
    },
    eveningMedications: {
      type: Array,
    },
    dailyPRNMedications: {
      type: Array,
    },
    staff: {
      type: String,
    },
    userSignatureTz: {
      type: Object,
    },
    clientData: {
      type: Object,
    },
    medCertified: {
      type: Boolean,
      default: false,
    },
    userRole: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      msg: false,
      text: "",
      color: "",
      isSaving: false,
      clientID: this.$route.params.clientID,
      userID: localStorage.getItem("userID"),
      cardIndex: null,
      diagnosisCardIndex: null,
      diagnosisReveal: false,
      reveal: false,
      exceptionDialog: false,
      shareLinkDialog: false,
      confirmationDialog: false,
      adminTime: [
        "12:00am",
        "1:00am",
        "2:00am",
        "3:00am",
        "4:00am",
        "5:00am",
        "6:00am",
        "7:00am",
        "8:00am",
        "9:00am",
        "10:00am",
        "11:00am",
        "12:00pm",
        "1:00pm",
        "2:00pm",
        "3:00pm",
        "4:00pm",
        "5:00pm",
        "6:00pm",
        "7:00pm",
        "8:00pm",
        "9:00pm",
        "10:00pm",
        "11:00pm",
        "PRN",
      ],
      exceptions: [
        "Absent",
        "Dropped",
        "Medication Unavailable",
        "Spit Out",
        "Meds on Hold",
        "Refused",
        "Low Vitals",
        "High Vitals",
        "Other",
      ],
      newMedication: "",
      newMedicationId: "",
      newAmountAdministered: "",
      newAdminTime: "",
      unsignedList: [],
      unsignedNewList: [],
      newNotes: "",
      newException: "",
      newSignature: "",
      newSignatureData: "",
      newSignatureDataAdd: "",
      newVerifiedBy: "",
      newDate: "",
      multipleSelectedItem: false,
      signed: false,
      selectedIndex: [],
      selectedMAR: [],
      chkReset: [],
      notes: "test",
      msg: false,
      text: "",
      color: "",
      sample: "",
      schedule: {
        morning: "Morning",
        afternoon: "Afternoon",
        evening: "Evening",
        daily: "Daily/PRN",
      },
      selectedMedication: "",
      error: null,
      disableButton: false,
      generatedURL: "",
      isSaveInventory: false,
      confirmedDialog: false,
      itemData: "",
      title: "Confirming...",
      content: "Do you confirm administering the medication?",
      insulinDialog: false,
      medicationItem: "",
      isControlled: false,
      controlledDialog: false,
      controlledSubstance: "",
    };
  },

  created() {
    this.$emit("getMAR");
  },

  computed: {
    ...mapState({
      dialog: (state) => state.medications.dialog,
      confirmed: (state) => state.medications.confirmed,
    }),

    isDisable: {
      get() {
        return this.$store.state.medications.isDisableButton;
      },
      set(val) {
        this.$store.commit("medications/SET_DISABLE_BUTTON", val);
      },
    },

    medication() {
      const value = 100;

      const adminTime = (med) => {
        const incomplete =
          med.filter((item) => item.isAdministered).length != med.length;

        const completed = med.filter((item) => item.isAdministered).length;

        const total = med.length;

        return {
          incomplete: incomplete,
          completed: completed,
          total: total,
          progress: (value / total) * completed,
        };
      };

      return {
        morning: adminTime(this.morningMedications),
        afternoon: adminTime(this.afternoonMedications),
        evening: adminTime(this.eveningMedications),
        daily: adminTime(this.dailyPRNMedications),
      };
    },

    sortedMedications() {
      const sortByTimeThenMedication = (a, b) => {
        const med = a.Medication.localeCompare(b.Medication);
        const aAdminTime = moment(a.newAdminTime, "h:mma").format("HH:mm");
        const bAdminTime = moment(b.newAdminTime, "h:mma").format("HH:mm");
        if (aAdminTime === bAdminTime) {
          return med;
        } else {
          return aAdminTime.localeCompare(bAdminTime);
        }
      };

      return {
        morningMedications: this.morningMedications.sort(
          sortByTimeThenMedication
        ),
        afternoonMedications: this.afternoonMedications.sort(
          sortByTimeThenMedication
        ),
        eveningMedications: this.eveningMedications.sort(
          sortByTimeThenMedication
        ),
        dailyPRNMedications: this.dailyPRNMedications.sort(
          sortByTimeThenMedication
        ),
      };
    },

    instructionLength() {
      return (data) =>
        data.Instructions.length > 90 || data.Instructions.length < 0;
    },

    diagnosisLength() {
      return (data) => data.Diagnosis.length > 80 || data.Diagnosis.length < 0;
    },

    defaultMargin() {
      return this.$vuetify.breakpoint.xsOnly ? "pa-0 my-3" : "pa-3";
    },
  },

  watch: {
    sortedMedications() {
      return;
    },
  },

  methods: {
    ...mapActions({
      addMultipleMAR: "medications/addMultipleMAR",
      addShearableLink: "shareLink/addItem",
    }),

    ...mapMutations({
      setChat: "SET_CHAT",
      setIsSaving: "SET_IS_SAVING",
      setIsSelectedMultipleItem: "SET_IS_SELECTED_MULTIPLE_ITEM",
      setDialog: "SET_DIALOG",
      setConfirmedDialog: "medications/SET_CONFIRMED_DIALOG",
    }),

    instruction(index) {
      this.cardIndex = index;
      this.reveal = true;
    },

    diagnosis(index) {
      console.log(index);
      this.diagnosisCardIndex = index;
      this.diagnosisReveal = true;
    },

    selectedItem(data) {
      let index = this.selectedIndex[data.generatedId];

      if (index === undefined) {
        index = this.selectedMAR.length;
        this.selectedIndex[data.generatedId] = index;
      }

      this.selectedMAR[index] = data;

      this.selectedMAR.filter((item) => item.active === true).length >= 2
        ? (this.multipleSelectedItem = true)
        : (this.multipleSelectedItem = false);

      this.setChat(!this.multipleSelectedItem);
    },

    async save() {
      this.setConfirmedDialog(false);
      this.isDisable = true;
      let med = this.itemData;

      var req_body = {
        Medication: med._id,
        MedicationName: med.Medication,
        AmountAdministered: med.newAmountAdministered,
        AdminTime: med.time,
        Notes: med.newNotes,
        Exception: med.newException,
        Signature: med.newSignature,
        VerifiedBy: med.newVerifiedBy,
        ClientID: this.clientID,
        Quantity:
          this.selectedMedication.isControlled === "Yes"
            ? this.controlledSubstance.amount
            : med.Quantity,
        Date: new Date(),
        StaffID: this.userID,
        PRN: med.PRN,
        Insulin: med.Insulin,
        UrlNotification: this.$router.history.current.path,
        NewVitalsRequired: med.newVitalsRequired,
        VitalsRequired: med.VitalsRequired,
        ActualAdminTime: setUserSignatureTz(this.userSignatureTz),
        isControlled:
          this.selectedMedication.isControlled === "Yes" ? true : false,
        ControlledSubstance: {
          ...this.controlledSubstance,
          id: med?.MedInventory?._id,
          quantity: med.MedInventory.Quantity,
        },
      };

      try {
        const response = await axios.post(`${url}/MAR`, req_body);

        if (!response.data.success || response.status == 400) {
          this.isDisable = false;
          return this.messageDialog(true, "error", response.data.msg);
        }

        this.$emit("getMAR");
        this.messageDialog(
          true,
          "pink",
          "The new MAR item has been added successfully."
        );
      } catch (error) {
        this.isDisable = false;
        console.log(error);
      }
    },

    async addMAR(med) {
      let countError = 0;

      let bloodSugar = med.VitalsRequired.includes("BloodSugar");
      if (this.isInSelectedMar(med._id)) {
        med.newSignature = this.newSignature;
      }

      if (med.newSignature === "") {
        med.error = "Signature is required";
        countError++;
      }

      if (
        bloodSugar &&
        med.Insulin === "" &&
        this.checkMedicationType(med.Medication)
      ) {
        med.insulinError = `Insulin is required`;
        countError++;
      }

      med.newVitalsRequired?.forEach((value, index) => {
        let vital = med.VitalsRequired[index].replace(/([A-Z])/g, " $1").trim();
        if (value == "") {
          med.ErrorVitalsRequired[index] = `${vital} is required`;
          countError++;
        } else {
          return (
            (med.ErrorVitalsRequired[index] = ""), (this.isDisable = false)
          );
        }
      });

      if (countError == 0) {
        this.setConfirmedDialog(true);
        this.itemData = med;
      } else {
        return med.ErrorVitalsRequired, med.error, (this.isDisable = false);
      }
    },

    addSignature(med) {
      if (this.signed) {
        this.newSignature =
          this.staff + " - " + setUserSignatureTz(this.userSignatureTz);
        this.error = "";
      } else {
        this.newSignature = "";
        this.error = "";
      }

      if (med.signed) {
        med.newSignature =
          this.staff + " - " + setUserSignatureTz(this.userSignatureTz);
        med.error = "";
      } else {
        med.newSignature = "";
        med.error = "";
      }
    },

    async addAttendance() {
      let client = this.clientData;
      try {
        var req_body = {
          Code: client?.medicationCode.join(),
          Date: new Date(),
          Signature: this.staff + " - " + this.userSignatureTz,
          ClientID: this.clientID,
          Units: 1,
          medicationUnit: "Daily",
        };
        await axios.post(`${url}/attendance`, req_body).then((res) => {
          if (res.status == 200) {
            console.log(res.data.msg);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    addMultipleItem() {
      // this.setIsSaving(true);
      this.isDisable = true;

      if (this.newSignature === "") {
        return this.selectedMAR.map((item) => {
          if (item.error === "") {
            this.isDisable = false;
            return (this.error = "Signature is required");
          }
        });
      }

      const MARfilteredData = this.selectedMAR
        .filter((item) => item.active === true)
        .map((med) => ({
          Medication: med._id,
          MedicationName: med.Medication,
          AmountAdministered: med.newAmountAdministered,
          AdminTime: med.newAdminTime,
          Notes: this.newNotes,
          Exception: this.newException,
          Signature: this.newSignature,
          VerifiedBy: med.newVerifiedBy,
          ClientID: this.clientID,
          Quantity: med.Quantity,
          Date: new Date(),
          StaffID: this.userID,
          PRN: med.PRN,
          UrlNotification: this.$router.history.current.path,
          NewVitalsRequired: med.newVitalsRequired,
          VitalsRequired: med.VitalsRequired,
          ActualAdminTime: setUserSignatureTz(this.userSignatureTz),
        }));

      this.addMultipleMAR(MARfilteredData)
        .then((res) => {
          if (res.status !== 200) {
            this.messageDialog(true, "error", res[1]);
            return;
          }

          this.messageDialog(
            true,
            "pink",
            "The new MAR item has been added successfully."
          );

          this.isDisable = false;

          // this.addAttendance();
          this.msg = true;
          this.color = "pink";
          this.text = "The new MAR item has been added successfully.";
          this.multipleSelectedItem = false;
          this.selectedMAR = [];
          this.selectedIndex = [];
          this.setChat(true);
          this.$emit("getMAR");
        })
        .finally(
          () =>
            // this.setIsSaving(false)
            (this.isDisable = false)
        );
    },

    onSelectQuantity(qty, item) {
      item.newException = "";
      let dosage = item.Dosage.split("mg")[0];
      let totalDosage = dosage * qty;
      if (item.Dosage === "" || Number.isNaN(totalDosage))
        return (item.AdministerAmount = "");
      item.AdministerAmount = totalDosage + "mg";
    },

    updateText(val) {
      this.newNotes = val;
      this.notes = val;
    },

    onSelectException(med) {
      if (this.isClear) {
        this.isClear = false;
        return (this.exceptionDialog = false);
      }
      this.selectedMedication = med;
      this.exceptionDialog = true;
    },

    onClear(item) {
      this.isClear = item;
      this.exceptionDialog = !item;
    },

    setQuantity(value) {
      this.selectedMedication.Quantity = value;
      this.exceptionDialog = false;
      this.selectedMedication.AdministerAmount = 0;
      this.selectedMedication.newAmountAdministered = "";
    },

    async createShareLink(med) {
      let originUrl = window.location.origin + "/sharing/mar/?code=";
      const data = {
        longUrl: originUrl,
        shortUrl: shareUrl,
        date: new Date(),
        shareUrlInfo: {
          id: med._id,
          time: med.newAdminTime,
          clientId: med.ClientID,
        },
      };

      const response = await this.addShearableLink(data);
      this.generatedURL = response.shortUrl;

      this.shareLinkDialog = true;
    },

    close() {
      this.shareLinkDialog = false;
      this.generatedURL = "";
    },

    fetchMAR() {
      this.$emit("getMAR");
    },

    messageDialog(msg, color, text) {
      this.msg = msg;
      this.color = color;
      this.text = text;
    },

    openInsulinDialog(med, times) {
      let targetBg = 0;
      let bloodSugarIndex = med.VitalsRequired.findIndex(
        (item) => item === "BloodSugar"
      );

      times === "morning" || times === "afternoon"
        ? (targetBg = 120)
        : (targetBg = 150);

      this.medicationItem =
        {
          ...med,
          bloodSugar: med.newVitalsRequired[bloodSugarIndex],
          targetBg,
          times,
        } || {};
      this.selectedMedication = med;
      this.insulinDialog = true;
    },

    closeInsulinDialog(item) {
      this.insulinDialog = false;
      this.selectedMedication.Insulin = item.totalUnits;
    },

    closeExeptionDialog() {
      this.exceptionDialog = false;
      this.selectedMedication.newException = "";
    },

    checkError(med, index) {
      let vital = med.VitalsRequired[index].replace(/([A-Z])/g, " $1").trim();
      if (med.newVitalsRequired[index] != "")
        return (med.ErrorVitalsRequired[index] = "");
      return (med.ErrorVitalsRequired[index] = `${vital} is required`);
    },

    checkMedicationType(medication) {
      //Check only insulin-type medications.
      let regex = /admelog/i;
      return regex.test(medication);
    },

    onSelectControlled(med) {
      this.selectedMedication = med;
      if (med.isControlled === "Yes") {
        this.$refs.controlled.showDialog();
      }
    },

    closeControlledDialog() {
      this.selectedMedication.isControlled = "";
    },

    getControlledData(item) {
      this.controlledSubstance = item;
    },

    isInSelectedMar(id) {
      return this.selectedMAR.some((item) => item._id === id);
    },

  },
};
</script>

<style scoped>
.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(
    .v-expansion-panel-header__icon--disable-rotate
  )
  .v-icon {
  transform: none !important;
}

.main-container {
  border-radius: 0 !important;
}

.mar-card--container {
  position: relative;
}

.mar-checkbox {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 5px;
}

.bg-color {
  background: linear-gradient(
    169deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(2, 97, 217, 1) 0%,
    rgba(30, 177, 148, 1) 100%
  );
}

.v-card--reveal {
  bottom: 0;
  left: 0;
  opacity: 1 !important;
  position: absolute;
  width: 10 0%;
  background-color: #fff;
  border-radius: 0 !important;
}

.panel-header {
  min-height: 100px;
}

.item-container {
  height: 150px;
}

.diagnosis-container {
  position: relative;
}

.item-container--diagnosis {
  height: 80px;
}

.fab-multiple {
  z-index: 999;
}
</style>
